// /admin — real route. Mirrors apps/web's app/admin/page.tsx: fully
// self-contained 'use client' overview dashboard (fetches its own stats via
// /api/admin/*, no route params needed), so it's lazy-imported directly per
// the porting convention (route-helpers.tsx). Registered into the route
// tree from routes/admin.tsx under the `_admin` guard (routes/guards.tsx),
// parity with app/admin/layout.tsx:6.
import { lazy } from 'react';
import { createRoute } from '@tanstack/react-router';
import { adminRoute } from './guards';

const AdminOverviewPage = lazy(() => import('@/app/admin/page'));

export const adminOverviewRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: '/admin',
  component: AdminOverviewPage,
});
